exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".square-image[data-v-2e55f531]{max-height:100%;max-width:100%;object-fit:contain}", ""]);

